import { Component } from '@angular/core';
import { CopyButtonComponent } from '../copy-button/copy-button.component';

@Component({
  selector: 'app-monospaced-block',
  imports: [CopyButtonComponent],
  templateUrl: './monospaced-block.component.html',
  styleUrl: './monospaced-block.component.scss',
})
export class MonospacedBlockComponent {}
